/**
 * Get the corresponding pageName property based on the current route.
 *
 * @param {string} pathname
 * @param {number} numberOfLastPartURL - the number of the last part of URL
 * @returns {string} pageName
 */
const getLastSegmentUrl = (pathname, numberOfLastPartURL = 1) => {
  if (!pathname || pathname === '/' || numberOfLastPartURL === 0) {
    return ''; // Handle empty pathname or just a '/'
  }

  const segments = pathname.split('/').filter((segment) => segment.trim() !== ''); // Split and remove empty segments
  if (segments.length < numberOfLastPartURL) {
    return '';
  }

  return segments.slice(-numberOfLastPartURL).join('/');
};

export default getLastSegmentUrl;
